export default {
  'Extract audio': 'Extraer audio',
  'Mute': 'Mudo',
  'Split video and audio': 'Dividir vídeo y audio',
}